import React, { useState, useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import SidebarEspacios from '../../components/espacios/SidebarEspacios';
import './EspaciosGlobal.css';

const DetalleAreaEspacios = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const queryParams = new URLSearchParams(location.search);
  const areaId = queryParams.get('areaId');

  const [area, setArea] = useState(null);
  const [espacios, setEspacios] = useState([]);
  const [loading, setLoading] = useState(true);
  const [showModal, setShowModal] = useState(false);
  const [saving, setSaving] = useState(false);
  const [newEspacio, setNewEspacio] = useState({
    nombre: '',
    tipo: '',
    capacidad: '',
    equipamiento: '',
    estado: 'Disponible',
    requiere_llave: false
  });

  const user = JSON.parse(localStorage.getItem('user_espacios') || '{}');
  const initial = user.nombre ? user.nombre.charAt(0).toUpperCase() : 'A';

  const isLocal = window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1';
  const apiBase = isLocal ? `http://${window.location.hostname}:3010` : `${window.location.protocol}//${window.location.hostname}`;

  useEffect(() => {
    if (!localStorage.getItem('user_espacios')) {
      navigate('/espacios/login');
      return;
    }
    if (areaId) {
      fetchData();
    } else {
      navigate('/espacios/areas');
    }
  }, [areaId]);

  const fetchData = async () => {
    try {
      const [areaResp, espaciosResp] = await Promise.all([
        fetch(`${apiBase}/api/espacios/areas/${areaId}`, { credentials: 'include' }),
        fetch(`${apiBase}/api/espacios/espacios?area_id=${areaId}`, { credentials: 'include' })
      ]);
      const areaData = await areaResp.json();
      const espaciosData = await espaciosResp.json();
      setArea(areaData);
      setEspacios(espaciosData);
    } catch (err) {
      console.error('Error fetching data:', err);
    } finally {
      setLoading(false);
    }
  };

  const handleCreateEspacio = async (e) => {
    if (e) e.preventDefault();
    if (!newEspacio.nombre) return;
    setSaving(true);
    try {
      const resp = await fetch(`${apiBase}/api/espacios/espacios`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ ...newEspacio, area_id: areaId }),
        credentials: 'include'
      });
      if (resp.ok) {
        setShowModal(false);
        setNewEspacio({ nombre: '', tipo: '', capacidad: '', equipamiento: '', estado: 'Disponible' });
        fetchData();
      } else {
        const errData = await resp.json();
        console.error('Error server:', errData);
        alert('Error al guardar: ' + (errData.error || 'Desconocido'));
      }
    } catch (err) {
      console.error('Error creating espacio:', err);
      alert('Error de conexión al servidor.');
    } finally {
      setSaving(false);
    }
  };

  if (loading) return (
    <div className="App-layout-espacios">
      <SidebarEspacios />
      <main className="App-main-espacios">
        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', height: '100%' }}>
          <div className="spinner"></div>
        </div>
      </main>
    </div>
  );

  return (
    <div className="App-layout-espacios">
      <SidebarEspacios />
      
      <main className="App-main-espacios">
        <header className="view-page-header">
          <div className="view-title-block">
            <button 
              className="btn-high-end" 
              onClick={() => navigate('/espacios/areas')}
              style={{ marginBottom: '16px', background: 'var(--esp-surface-light)', color: 'white', padding: '8px 16px', fontSize: '12px' }}
            >
              <i className="fa-solid fa-arrow-left"></i> Volver al listado
            </button>
            <h2>{area?.nombre || 'Gestión de Espacios'}</h2>
            <p>Unidades físicas configuradas para esta área</p>
          </div>
          <div className="header-actions">
            <button className="btn-high-end btn-high-end-primary" onClick={() => setShowModal(true)}>
              <i className="fa-solid fa-plus-circle"></i> Nuevo Espacio
            </button>
            <div className="user-pill-dark">
              <div className="avatar">{initial}</div>
              <span>{user.nombre || 'Administrador'}</span>
            </div>
          </div>
        </header>

        <section style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(340px, 1fr))', gap: '28px' }}>
          {espacios.map(espacio => (
            <div key={espacio.id} className="calendar-glass-card" style={{ display: 'flex', flexDirection: 'column', gap: '20px', padding: '28px' }}>
              <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                <div style={{ width: '48px', height: '48px', borderRadius: '12px', background: 'var(--esp-primary-soft)', color: 'var(--esp-primary)', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '20px' }}>
                  <i className="fa-solid fa-door-open"></i>
                </div>
                <span className={`badge-executive ${espacio.estado === 'Disponible' ? 'badge-emerald' : 'badge-amber'}`} style={{ padding: '6px 12px' }}>
                  {espacio.estado}
                </span>
              </div>
              
              <div>
                <h3 style={{ fontSize: '20px', fontWeight: '800', margin: 0 }}>{espacio.nombre}</h3>
                <div style={{ display: 'flex', gap: '16px', marginTop: '8px', color: 'var(--esp-text-muted)', fontSize: '13px' }}>
                  <span><i className="fa-solid fa-users" style={{ marginRight: '6px' }}></i> {espacio.capacidad || 0} paxs</span>
                  <span><i className="fa-solid fa-tags" style={{ marginRight: '6px' }}></i> {espacio.tipo || 'General'}</span>
                  {espacio.requiere_llave === 1 && (
                    <span style={{ color: 'var(--p-amber)', fontWeight: '800' }}>
                      <i className="fa-solid fa-key" style={{ marginRight: '6px' }}></i> Llave Req.
                    </span>
                  )}
                </div>
              </div>

              <div style={{ padding: '16px', background: 'rgba(255,255,255,0.02)', borderRadius: '12px', fontSize: '14px', border: '1px solid var(--esp-border)', minHeight: '80px' }}>
                <strong>Equipamiento Técnico:</strong><br />
                <span style={{ opacity: 0.8 }}>{espacio.equipamiento || 'Sin especificaciones registradas.'}</span>
              </div>

              <button className="btn-high-end btn-high-end-primary" style={{ width: '100%', justifyContent: 'center' }} onClick={() => navigate('/espacios/reservas')}>
                Ver Disponibilidad
              </button>
            </div>
          ))}
          
          {espacios.length === 0 && (
            <div className="calendar-glass-card" style={{ gridColumn: '1 / -1', textAlign: 'center', padding: '100px 40px' }}>
              <i className="fa-solid fa-folder-open" style={{ fontSize: '48px', color: 'var(--esp-text-muted)', opacity: 0.2, marginBottom: '20px' }}></i>
              <h3 style={{ color: 'var(--esp-text-muted)' }}>No hay espacios registrados en esta área</h3>
              <p style={{ color: 'var(--esp-text-muted)', marginTop: '10px' }}>Haz clic en "Nuevo Espacio" para añadir infraestructura.</p>
            </div>
          )}
        </section>

        {showModal && (
          <div className="modal-overlay" onClick={() => setShowModal(false)} style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.8)', backdropFilter: 'blur(10px)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 1000 }}>
            <div className="calendar-glass-card" style={{ maxWidth: '540px', width: '90%', padding: '40px' }} onClick={e => e.stopPropagation()}>
              <div style={{ marginBottom: '32px' }}>
                <h3 style={{ fontSize: '24px', fontWeight: '800' }}>Nuevo Espacio</h3>
                <p style={{ fontSize: '14px', color: 'var(--esp-text-muted)' }}>Asigne una unidad física al área "{area?.nombre}".</p>
              </div>
              
              <form onSubmit={handleCreateEspacio} style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '20px' }}>
                <div className="input-group" style={{ gridColumn: '1 / -1', display: 'flex', flexDirection: 'column', gap: '8px' }}>
                  <label style={{ fontSize: '11px', fontWeight: '800', color: 'var(--esp-text-muted)', textTransform: 'uppercase' }}>Nombre del Espacio</label>
                  <input 
                    type="text" 
                    value={newEspacio.nombre}
                    onChange={e => setNewEspacio({...newEspacio, nombre: e.target.value})}
                    placeholder="Ej: Sala de Juntas, Cancha 1, Auditorio..." 
                    style={{ border: '1px solid var(--esp-border)', borderRadius: '10px', padding: '12px', background: 'var(--esp-surface-light)', color: 'white', outline: 'none' }} 
                    required
                  />
                </div>
                <div className="input-group" style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
                  <label style={{ fontSize: '11px', fontWeight: '800', color: 'var(--esp-text-muted)', textTransform: 'uppercase' }}>Tipo / Categoría</label>
                  <input 
                    type="text" 
                    value={newEspacio.tipo}
                    onChange={e => setNewEspacio({...newEspacio, tipo: e.target.value})}
                    placeholder="Ej: Deportivo, Reunión..." 
                    style={{ border: '1px solid var(--esp-border)', borderRadius: '10px', padding: '12px', background: 'var(--esp-surface-light)', color: 'white', outline: 'none' }} 
                  />
                </div>
                <div className="input-group" style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
                  <label style={{ fontSize: '11px', fontWeight: '800', color: 'var(--esp-text-muted)', textTransform: 'uppercase' }}>Capacidad (Paxs)</label>
                  <input 
                    type="number" 
                    value={newEspacio.capacidad}
                    onChange={e => setNewEspacio({...newEspacio, capacidad: e.target.value})}
                    placeholder="Ej: 20" 
                    style={{ border: '1px solid var(--esp-border)', borderRadius: '10px', padding: '12px', background: 'var(--esp-surface-light)', color: 'white', outline: 'none' }} 
                  />
                </div>
                <div className="input-group" style={{ gridColumn: '1 / -1', display: 'flex', flexDirection: 'column', gap: '8px' }}>
                  <label style={{ fontSize: '11px', fontWeight: '800', color: 'var(--esp-text-muted)', textTransform: 'uppercase' }}>Equipamiento / Detalles Técnicos</label>
                  <textarea 
                    value={newEspacio.equipamiento}
                    onChange={e => setNewEspacio({...newEspacio, equipamiento: e.target.value})}
                    placeholder="Ej: Proyector, Climatización, 50 Sillas..." 
                  ></textarea>
                </div>

                <div className="input-group" style={{ gridColumn: '1 / -1' }}>
                  <label className="checkbox-premium" style={{ display: 'flex', alignItems: 'center', gap: '12px', cursor: 'pointer' }}>
                    <input 
                      type="checkbox" 
                      checked={newEspacio.requiere_llave}
                      onChange={e => setNewEspacio({...newEspacio, requiere_llave: e.target.checked})}
                      style={{ width: '20px', height: '20px', accentColor: 'var(--esp-primary)' }}
                    />
                    <span style={{ fontSize: '14px', fontWeight: '700' }}>Este espacio requiere entrega de llave física</span>
                  </label>
                </div>

                <div style={{ display: 'flex', gap: '16px', marginTop: '12px', gridColumn: '1 / -1' }}>
                  <button type="button" className="btn-high-end" style={{ flex: 1, background: 'var(--esp-surface-light)', color: 'white', justifyContent: 'center' }} onClick={() => setShowModal(false)}>Cancelar</button>
                  <button type="submit" className="btn-high-end btn-high-end-primary" style={{ flex: 2, justifyContent: 'center' }} disabled={saving}>
                    {saving ? 'Guardando...' : 'Crear Espacio'}
                  </button>
                </div>
              </form>
            </div>
          </div>
        )}
      </main>
    </div>
  );
};

export default DetalleAreaEspacios;
